import React, { useState, useRef, useEffect } from 'react';

const TestInput = () => {
  const [value, setValue] = useState('');
  const inputRef = useRef(null);
  
  console.log('TestInput render, value:', value);
  
  // Maintain focus even during re-renders
  useEffect(() => {
    if (inputRef.current && document.activeElement === inputRef.current) {
      const cursorPosition = inputRef.current.selectionStart;
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
          inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
        }
      }, 0);
    }
  });
  
  return (
    <div style={{ padding: '20px', border: '2px solid red', margin: '20px' }}>
      <h3>Test Input Component (Stable)</h3>
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={(e) => {
          console.log('Input changed to:', e.target.value);
          setValue(e.target.value);
        }}
        placeholder="Type here to test..."
        style={{
          width: '100%',
          padding: '10px',
          fontSize: '16px',
          border: '1px solid #ccc',
          borderRadius: '4px'
        }}
      />
      <p>Current value: {value}</p>
    </div>
  );
};

export default TestInput;
